import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as SharedNoteWebsocket from './sharednote.websocket';

export function* updateSharedNote(action: any): SagaIterator {
  try {
    SharedNoteWebsocket.updateSharedNote(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


export function* seenSharedNote(action: any): SagaIterator {
  try {
    SharedNoteWebsocket.seenSharedNote(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* deleteSharedNote(action: any): SagaIterator {
  try {
    SharedNoteWebsocket.deleteSharedNote(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* updateSharedNoteOrder(action: any): SagaIterator {
  try {
    SharedNoteWebsocket.updateSharedNoteOrder(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


// WEBPACK FOOTER //
// ./src/services/sharednote/sharednote.saga.ts